<div class="header" *ngIf="!checkout && account && account.id == 1">
  <h1>Gift Cards</h1>
  <h2>{{ totalCredit() | currency }}</h2>
</div>

<div class="add-credit">
  <mat-form-field>
    <input matInput placeholder="Gift Card Code" [(ngModel)]="creditCode" (keyup.enter)="redeem()">
  </mat-form-field>
  <div class="pv-button" (click)="redeem()">Redeem</div>
  <div class="warn-color">{{ errorMessage }}</div>
  <div *ngIf="!show && !checkout && credits && credits.length" (click)="show = true" class="load-more">
    Show My Gift Cards
  </div>
</div>


<div *ngIf="show && !checkout">
  <table class="table">
    <thead>
      <tr>
        <th>Code</th>
        <th>Amount Left</th>
        <th>Date Added</th>
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let credit of credits">
        <td>{{ credit.credit_code }}</td>
        <td>{{ (isExpired(credit) ? 0 : credit.amount) | currency }}</td>
        <td>{{ credit.ins_datetime | date }}</td>
      </tr>
    </tbody>
  </table>
</div>